// extracted by mini-css-extract-plugin
export default {"toastHeader":"createCourseToast_toastHeader__bHXdn","toastBodyContainer":"createCourseToast_toastBodyContainer__rsFB2","toastBody":"createCourseToast_toastBody__9+yxb"};